/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import urlJoin from 'proper-url-join';

import {
  baseUrl,
  buildSubEndpoint
} from '@ibm-watson/shared/modules/channels/api/integrations/integrationServer';
import { GeneralQueryParam } from '../../../../ts';
import { prependMfePrefixIfNeeded } from '../../../ia/util/url';

export function getCustomMessageURL(
  integrationID: string,
  instanceCRN?: string
): string {
  return prependMfePrefixIfNeeded(
    urlJoin(
      baseUrl,
      buildSubEndpoint('wwx', integrationID),
      'message',
      instanceCRN
        ? { query: { [GeneralQueryParam.INSTANCE_CRN]: instanceCRN } }
        : {}
    )
  );
}

export function getCustomConfigURL(integrationID: string): string {
  // Make sure to prepend the MFE prefix if we are executing as a Micro
  // Front-End from within WXO.
  return prependMfePrefixIfNeeded(
    urlJoin(baseUrl, buildSubEndpoint('wwx', integrationID), 'config')
  );
}
